// extracted by css-extract-rspack-plugin
export default {"labelDescriptionTooltip":"Label-module__labelDescriptionTooltip__Ve0N6VS"};